import axios from 'axios';

const URL_API_WEBLINK = process.env.VUE_APP_URL_API_INSTAGRAM;

export class InstagramApiService {
  
  getInstagram() {
    let config = {
      headers: {'Authorization': localStorage.getItem("token"), 'instalacion' : localStorage.getItem("instalacion")}
    };
    const url = `${URL_API_WEBLINK}getInstagram/${process.env.VUE_APP_INSTAGRAM_USER}`;
    return axios
      .get(url,config)
      .then(function(response) {
        return response.data;
       
      })
      .catch(function(error) {
        if (error.response.status===401 || error.response.status===403){
          window.location.href = process.env.VUE_APP_PATH + '#/logout'
        }
        throw error;
      });
  }
}